"use client";

import { Box, Container, Typography } from "@mui/material";
import color from "@/style/theme/Color";
import { layanan } from "@/data/Beranda";
import VerticalCard from "@/app/(user)/VerticalCard";

export function IndexLayanan() {
  return (
    <Box
      sx={{
        backgroundColor: color.dark_white,
        paddingTop: { xs: "64px", md: "80px" },
        paddingBottom: { xs: "80px", md: "96px" }
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Typography
            component="h2"
            sx={{
              display: "inline-block",
              position: "relative",
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
              color: color.primary,
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-12px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "80px",
                height: "6px",
                borderRadius: "3px",
                background: `linear-gradient(90deg, ${color.blue}, ${color.primary})`,
              },
            }}
          >
            Fasilitas & Layanan
          </Typography>
        </Box>

        <Box
          sx={{
            marginTop: "48px",
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1fr",
              md: "repeat(3, 1fr)",
              lg: "repeat(6, 1fr)"
            },
            gap: "24px"
          }}
        >
          {layanan.map((element, key) => (
            <VerticalCard
              key={key}
              title={element.title}
              image={element.image}
              path={element.path}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
}